import apiClient from '@shared/api'

import type ICommunityRole from '@shared/api/user-management/resources/community-controller/community-role'
import type ICommunity from '@shared/api/user-management/resources/community-controller/community'
import type ICommunityUser from '@shared/api/user-management/resources/community-controller/community-user'
import type ICreateCommunityUser from '@shared/api/user-management/resources/community-controller/create-user'
import type ICreateCommunity from '@shared/api/user-management/resources/organization/create-community'
import type { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const getCommunity = ({ communityId }: { communityId: string | string[] }): Promise<ICommunity> => {
  return apiClient.get(`/communities/${communityId}`)
}

export const searchCommunities = ({
  communityName,
}: {
  communityName: string
}): Promise<ICommunity[]> => {
  return apiClient.get(`/communities/search-v2?communityName=${communityName}`) 
}

export const getCommunityRoles = ({ communityId }: { communityId: string | string[] }): Promise<ICommunityRole[]> => {
  return apiClient.get(`/communities/${communityId}/roles`)
}

export const getCommunityUsers = ({ communityId }: { communityId: string | string[] }): Promise<ICommunityUser[]> => {
  return apiClient.get(`/communities/${communityId}/users`)
}

export const createCommunityUser = ({
  communityId,
  communityUser,
}: {
  communityId: string | string[]
  communityUser: ICreateCommunityUser
}): Promise<ICommunityUser> => {
  return apiClient.post(`/communities/${communityId}/users`, communityUser)
}

export const updateUserRoles = ({
  communityId,
  userId,
  roles,
}: {
  communityId: string | string[]
  userId: string | string[]
  roles: { roles: EUserRole[] }
}): Promise<EUserRole[]> => {
  return apiClient.put(`/communities/${communityId}/users/${userId}/roles`, roles)
}

export const getUserRoles = ({
  communityId,
  userId,
}: {
  communityId: string | string[]
  userId: string | string[]
}): Promise<{ roles: EUserRole[] }> => {
  return apiClient.get(`/communities/${communityId}/users/${userId}/roles`)
}

export const updateCommunity = ({
  communityId,
  communityData,
}: {
  communityId: string | string[]
  communityData: ICreateCommunity
}): Promise<ICommunity> => {
  return apiClient.put(`/communities/${communityId}`, communityData)
}

export const getCommunityUserRoles = ({
  communityId,
  userId,
}: {
  communityId: string | string[]
  userId: string | string[]
}): Promise<{ roles: EUserRole[] }> => {
  return apiClient.get(`/communities/${communityId}/users/${userId}/roles`)
}

export const deleteUserFromCommunity = ({
  communityId,
  userId,
}: {
  communityId: string
  userId: string | string[]
}): Promise<{ roles: EUserRole[] }> => {
  return apiClient.delete(`/communities/${communityId}/users/${userId}`)
}
